import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useInView } from 'react-intersection-observer';
import useDebounce from './helpers/useDebounce';

function Lazy({ children, threshold, debounce, containerClassName }) {
  const [loaded, needLoading] = useState(false);

  const [containerRef, inView] = useInView({
    threshold,
    triggerOnce: true,
  });

  useDebounce(
    () => {
      if (inView && !loaded) {
        needLoading(true);
      }
    },
    debounce,
    [inView]
  );

  if (!loaded) {
    return <div className={containerClassName} ref={containerRef} />;
  }

  return children;
}

Lazy.propTypes = {
  threshold: PropTypes.number,
  debounce: PropTypes.number,
  containerClassName: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.element]),
};

Lazy.defaultProps = {
  threshold: 0,
  debounce: 0,
};

export default Lazy;
